// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SocialLogin-displayFlexIcon-ikl_8 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 10px;
    color: var(--primary-foreground) !important;
    font-weight: 500;
}

.SocialLogin-bgColor-jmm1y {
    background-color: var(--tertiary-gray-bg);
    border-radius: 24px;
    padding: 7px 22px 7px 7px;
    min-width: 123px;
    max-width: 123px;
    margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/components/SocialLogin/SocialLogin.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":[".displayFlexIcon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    color: var(--primary-foreground) !important;\n    font-weight: 500;\n}\n\n.bgColor {\n    background-color: var(--tertiary-gray-bg);\n    border-radius: 24px;\n    padding: 7px 22px 7px 7px;\n    min-width: 123px;\n    max-width: 123px;\n    margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"displayFlexIcon": `SocialLogin-displayFlexIcon-ikl_8`,
	"bgColor": `SocialLogin-bgColor-jmm1y`
};
module.exports = ___CSS_LOADER_EXPORT___;
